// src/components/Footer.jsx
import React from "react";
import "../styles/footer.css";

export default function Footer() {
  return (
    <footer>
      <nav>
        <a href="/about">About</a>
        <a href="/projects">Projects</a>
        <a href="/skills">Skills</a>
        <a href="/research">Research</a>
        <a href="/certifications">Certifications</a>
        <a href="/contact">Contact</a>
      </nav>
    </footer>
  );
}
